import { Modal } from 'react-bootstrap';

interface ModalProps {
  isOpen: boolean;
  toggle: Function;
}

export const ModalHelp: React.FC<ModalProps> = (props: ModalProps) => {
  const { isOpen, toggle } = props;

  return (
    <Modal
      onHide={toggle}
      show={isOpen}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton className='gradientBlue colorWhite'>
        <Modal.Title id="contained-modal-title-vcenter">
          Ayuda
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-2 bg-light'>
        <div className='d-flex flex-column'>
          <p className='mb-4 fs-5 text-primary'>
            <strong>Activación de la autenticación en dos fases:</strong>
          </p>
          <p className='mb-4 fs-6'>
            Al activar la autenticación en dos fases, el <strong>Pin Usuario</strong> recibirá instrucciones por correo electrónico para configurar el doble factor de autenticación.
          </p>
          <p className='mb-4 fs-5 text-danger'>
            <strong>Desactivación de la autenticación:</strong>
          </p>
          <p className='mb-4 fs-6'>
            Si desactivas la autenticación, perderás toda la configuración actual y se deberá seguir el procedimiento de activación desde el principio.
          </p>
          <p className='mb-4 fs-5 text-warning'>
            <strong>Pendiente de activación:</strong>
          </p>
          <p className='mb-4 fs-6'>
            En caso de ver el mensaje 'Pendiente de activar', el Usuario deberá seguir las instrucciones para activar el doble factor de autenticación. Las indicaciones correspondientes se enviarán al correo configurado, accesible desde la ventana 'Editar Pin Usuario'.
          </p>
          <p className='mb-0 fs-6 text-muted'>
            <strong>Nota:</strong> Si cambias la dirección de correo electrónico asociada al <strong>Pin Usuario</strong>, deberás seguir el procedimiento de activación nuevamente.
          </p>
        </div>

      </Modal.Body>
      <Modal.Footer className='bg-light'>
        <button onClick={() => toggle()} className="btn btn-light btn-outline-secondary float-right">Cerrar</button>
      </Modal.Footer>
    </Modal>
  )
}